// src/components/HomePage/Section3/index.js
import React from 'react';
import {
  Container,
  ContentContainer,
  AppInterface,
  IconCircle,
  IconText,
  QuestionBox,
  QuestionText,
  ImageContainer,
  CertificationImageme,
  ResponseBubble,
  ResponseText,
  PromotionalContent,
  MainTitle,
  Subtitle,
  ButtonsContainer,
  PrimaryButton,
  SecondaryButton
} from './styles';

import certificationimage from '../../../images/certification.png';

const Section6 = () => {
  return (
    <Container>
      <ContentContainer>
        <AppInterface id="certificados">
          <IconCircle>
            <IconText>FluencIA</IconText>
          </IconCircle>
          
          <QuestionBox>
            <QuestionText>
              Certificados Emitidos por Níveis e Categoria 🎓
            </QuestionText>
          </QuestionBox>
          
          <ImageContainer>
            <CertificationImageme src={certificationimage} alt="Cenário de cidade italiana" />
          </ImageContainer>
          
          <ResponseBubble>
            <ResponseText>
              Certificado gerado com sucesso! 🎉
            </ResponseText>
          </ResponseBubble>
        </AppInterface>
        
        <PromotionalContent>
          <MainTitle>
          Conversação, gramática e vocabulário no seu celular, sem pagar muito por isso
          </MainTitle>
          
          <Subtitle>
            Use os certificados como reconhecimento no LinkedIn além de obter benefícios exclusivos ao concluir as tarefas.
          </Subtitle>
          
          <ButtonsContainer>
            <PrimaryButton>
              Quero Aprender Inglês
            </PrimaryButton>
            
            <SecondaryButton>
              Demonstração
            </SecondaryButton>
          </ButtonsContainer>
        </PromotionalContent>
      </ContentContainer>
    </Container>
  );
};

export default Section6;
